<template>
  <div class="app-cart" >
    <h2 class="h3"><slot name="lblHeadline">Deine Kostenübersicht</slot></h2>
    <table class="cart--row price-table">
      <caption class="sr-only"><slot name="captionPriceTable">Preise</slot></caption>
      <tbody>

      <template v-if="this.newTariffSelected && this.targetTariff">
        <tr aria-live="polite" aria-atomic="true">
          <td>
            <strong><slot name="lblConnectionFee">Deine zukünftige Grundgebühr</slot> <span class="small"><slot name="lblMonthly">(monatlich)</slot></span></strong>
          </td>
            <td>
              <span class="sr-only">{{ priceWithoutEuro(promoBenefits.promoPrice.promoAmount) }} €</span>
              <span aria-hidden="true" class="new-price--amount"><strong>{{ priceWithoutEuro(promoBenefits.promoPrice.promoAmount) }}</strong></span>
              <span aria-hidden="true" class="new-price--label"><strong>&nbsp;&euro;</strong></span>
          </td>
        </tr>
      </template>

      <tr>
        <td>
            <strong><slot name="lblPrice">Deine aktuelle Grundgebühr</slot> <span class="small"><slot name="lblMonthly">(monatlich)</slot></span></strong>
        </td>
        <td>
          <span class="sr-only">{{ priceWithoutEuro(prevFee) }} €</span>
          <span aria-hidden="true" class="price--amount"><strong>{{ priceWithoutEuro(prevFee) }}</strong></span>
          <span aria-hidden="true" class="price--label"><strong>&nbsp;&euro;</strong></span>
        </td>
        </tr>

      <template v-if="this.newTariffSelected && this.targetTariff">
        <tr>
          <td>
            <strong><slot name="lblShippingCosts">Versandkosten</slot> <span class="small"><slot name="lblOnetime">(einmalig)</slot></span></strong>
          </td>
          <td>
            <strong>0 &euro;</strong>
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <div class="cart--row features">
      <div>
        <ul class="checklist">
          <li class="volume">
            <span class="volume--amount" v-if="!(this.newTariffSelected && this.targetTariff)">
              <strong>{{ prevVolume }} GB</strong>
            </span>
            <span class="volume--amount" v-else>
              <strong>{{promoBenefits.volume.promoAmount}} {{promoBenefits.volume.unit}}</strong>
            </span>
            <span class="sr-only">monatlich</span>
            <span aria-hidden="true">&nbsp;mtl.</span>
          </li>
          <slot name="listTariffHighlights"><li>Bulletpoints</li></slot>
        </ul>
      </div>
      <div aria-hidden="true" class="trustedShops"><slot name="imageTrustedShops"></slot></div>
    </div>
    <div class="cart--row infos">
      <strong><slot name="lblTax">Alle Preise inkl. MwSt.</slot></strong>
      <div><slot name="txtInfoLink">Tarifinformationen</slot></div>
    </div>
    <div v-if="showPromoInfo">
      <div class="info-box">
        <slot name="txtInfoPromo"><strong>Wichtiger Hinweis:</strong> Die angezeigten Tarifinhalte beziehen sich nicht auf deine laufenden Promotionen.</slot>
      </div>
    </div>
  </div>
</template>

<script>

import price from '@/mixins/formatters/price'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import { mapGetters } from 'vuex'
import date from '@/mixins/validators/date'

export default {
  name: 'Cart',
  mixins: [
    price,
    formatDecimal,
    date
  ],
  data () {
    return {}
  },
  props: {
    promoBenefits: {
      type: Object,
      default: null
    },
    targetTariff: {
      type: Object,
      default: null
    },
    newTariffSelected: {
      type: Boolean,
      default: false
    },
    prevPromotions: {
      type: Array,
      default: () => []
    }
  },
  methods: {},
  computed: {
    ...mapGetters('checkoutv2/belatedPorting/_cart', {
      prevAboOption: 'bookedAboOption',
      prevTariff: 'bookedTariff',
      prevFee: 'bookedPrice',
      prevVolume: 'bookedVolume'
    }),
    showPromoInfo () {
      let hasLimitedPromo = false
      this.prevPromotions?.forEach(promo => {
        if (promo.duration || !this.isPermanentDate(promo.expirationDate)) {
          hasLimitedPromo = true
        }
      })
      return hasLimitedPromo
    }
  }
}
</script>
